export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div style={overlay} onClick={onCancel}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 18, fontWeight: 700, color: '#0f172a', marginBottom: 10 }}>{title}</div>
        <div style={{ color: '#475569', fontSize: 14, lineHeight: 1.5, marginBottom: 20 }}>{message}</div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button style={cancelButton} onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button style={danger ? dangerButton : confirmButton} onClick={onConfirm} disabled={busy}>
            {busy ? 'Please wait…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

const overlay = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(15, 23, 42, 0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  animation: 'fadeIn 0.15s ease-out',
};

const modal = {
  background: '#ffffff',
  borderRadius: 20,
  padding: 24,
  width: 420,
  maxWidth: 'calc(100vw - 48px)',
  boxShadow: '0 20px 50px rgba(15, 23, 42, 0.25)',
};

const cancelButton = {
  border: '1px solid #94a3b8',
  borderRadius: 999,
  padding: '10px 18px',
  background: '#fff',
  color: '#0f172a',
  fontWeight: 700,
  cursor: 'pointer',
};

const confirmButton = {
  border: 'none',
  borderRadius: 999,
  padding: '10px 18px',
  background: '#0f766e',
  color: '#fff',
  fontWeight: 700,
  cursor: 'pointer',
};

const dangerButton = {
  border: 'none',
  borderRadius: 999,
  padding: '10px 18px',
  background: '#dc2626',
  color: '#fff',
  fontWeight: 700,
  cursor: 'pointer',
};
